import React from 'react'
import Logo from '../../images/kneerom-logo.svg'

const Image = (props) => <img alt="KneeROM Logo" src={Logo} {...props} />

export default Image
